module.exports = "/packs/media/images/LatteArt-1e787f762a4a06574e91c2676ea24794.jpeg";